module.exports = __webpack_public_path__ + "img/company_associated-companies.c570a9f3.svg";